import { render, staticRenderFns } from "./companyReportTabEmployees.vue?vue&type=template&id=7d65c4e1"
import script from "./companyReportTabEmployees.vue?vue&type=script&lang=js"
export * from "./companyReportTabEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports